import { Fragment } from 'react';
import { Table, TabPane  } from 'reactstrap';
import { Amount, DateCreated, DateModified, Description, FiscalYear, InventoryClass, InventoryGroup, InventoryType, Name, Status } from '../../../../../../Constant';
import DataTableComponent from "../../../../../Common/Component/DataTableComponent";
import useBudgetInventoryPriceGuide from "./controller";
import ViewModal from '../../../../../Common/Component/ViewModal';
import { formatDateWithTimeZone } from '../../../../../../_helper/dateHelper';
import { IFiscalYearResponse } from '../../controller';

const InventoryList = (name: any,  fiscal_year: IFiscalYearResponse) => {
    
    const {
        data,
        tableColumns,
        handleView,
        handleEdit,
        viewModalOpen,
        selectedRowData,
        setViewModalOpen,
        formFields,
        memoizedHandleEdit,
        editMode,
        title,
        loading,
    } = useBudgetInventoryPriceGuide(fiscal_year);

    return (
        <Fragment>
            <TabPane className='fade show' tabId={name.name}>
                <DataTableComponent
                    tabledata={data}
                    tableColumns={tableColumns}
                    isLoading={loading}
                    onView={handleView}
                    // onDelete={handleDelete}
                    onEdit={handleEdit}
                    useTableAction={undefined}
                    addToDefaultAction={undefined}
                    onDelete={undefined}
                />

                <ViewModal
                    isOpen={viewModalOpen}
                    toggle={() => setViewModalOpen(!viewModalOpen)}
                    rowData={selectedRowData}
                    formFields={formFields}
                    editMode={editMode}
                    onEdit={memoizedHandleEdit}
                    onSubmit={undefined}
                    modalTitle={undefined}
                >
                    {selectedRowData && (
                    <>
                        <Table>
                        <tbody>
                            <tr className="border-bottom-primary">
                                <th scope="row">{FiscalYear}</th>
                                <td>{selectedRowData.finance_fiscal_year.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{Name}</th>
                                <td>{selectedRowData.administration_inventory_description.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{Amount}</th>
                                <td>{selectedRowData.amount}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{InventoryType}</th>
                                <td>{selectedRowData.administration_inventory_description.administration_inventory_type.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{InventoryClass}</th>
                                <td>{selectedRowData.administration_inventory_description.administration_inventory_type.administration_inventory_class.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{InventoryGroup}</th>
                                <td>{selectedRowData.administration_inventory_description.administration_inventory_type.administration_inventory_class.administration_inventory_group.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{Description}</th>
                                <td>{selectedRowData.administration_inventory_description.description}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                            <th scope="row">{Status}</th>
                            <td>
                                {selectedRowData.is_active ? (
                                <span className="badge badge-light-success">
                                    Active
                                </span>
                                ) : (
                                <span className="badge badge-light-danger">
                                    Inactive
                                </span>
                                )}
                            </td>
                            </tr>
                            <tr className="border-bottom-primary">
                            <th scope="row">{DateCreated}</th>
                            <td>
                                {formatDateWithTimeZone(selectedRowData.created_at)}
                            </td>
                            </tr>

                            <tr className="border-bottom-primary">
                            <th scope="row">{DateModified}</th>
                            <td>
                                {formatDateWithTimeZone(selectedRowData.updated_at)}
                            </td>
                            </tr>
                        </tbody>
                        </Table>
                    </>
                    )}
                </ViewModal>
            </TabPane>
        </Fragment>
    );
}

export default  InventoryList